export class Admin {
    id: string;
    active: boolean;
}
